import { render, staticRenderFns } from "./CascaderItem.vue?vue&type=template&id=1dee3d2c&scoped=true"
import script from "./CascaderItem.vue?vue&type=script&lang=js"
export * from "./CascaderItem.vue?vue&type=script&lang=js"
import style0 from "./CascaderItem.vue?vue&type=style&index=0&id=1dee3d2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee3d2c",
  null
  
)

export default component.exports